import { request } from "../../api/api";

export const changeCICPassword = (data) => {
  return request.post(`/updateMicrosoftEmailPassword/`, data);
};
